import { Injectable } from '@angular/core';
import {
  HttpContextToken,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest
} from "@angular/common/http";
import { Observable } from "rxjs";
import { finalize } from "rxjs/operators";
import { LoaderService } from "./loader.service";
import { NgxSpinnerService } from "ngx-spinner";

export const SKIP_LOADER = new HttpContextToken<boolean>(() => false);

@Injectable()
export class LoaderInterceptor implements HttpInterceptor {
  service_count = 0;
  constructor(public loaderService: LoaderService,
    private spinner: NgxSpinnerService) {}

  intercept(req: HttpRequest<any>,
    next: HttpHandler):  Observable<HttpEvent<any>>  {
  if (req.context.get(SKIP_LOADER)) {
      return next.handle(req);
    }

      this.service_count++;
    this.loaderService.show();
    return next.handle(req).pipe(finalize(() =>  {this.service_count--;
      if (this.service_count === 0) {
        this.loaderService.hide();
    }

    })
    );
  }

}
